import { render } from "./GestioneParametri.vue?vue&type=template&id=4c44f8f1&scoped=true"
import script from "./GestioneParametri.vue?vue&type=script&lang=js"
export * from "./GestioneParametri.vue?vue&type=script&lang=js"

import "./GestioneParametri.vue?vue&type=style&index=0&id=4c44f8f1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c44f8f1"]])

export default __exports__